import Layout from "../Layout";

export default function Casos() {
  return (
    <Layout>
      <></>
    </Layout>
  );
}
